import { useContext } from 'react';
import { GroupTagsContext } from '../Context';

export default function useGroupTags() {
  const value = useContext(GroupTagsContext);
  return value;
}

export { useGroupTags };